/* Prime RV: site-wide scroll-reveal. Tags top-level content blocks inside prv-* sections
   (and the footer) with .prv-reveal, then fades + rises each one into place the first time
   it enters the viewport, using IntersectionObserver. Styling for .prv-reveal / .prv-reveal-visible
   lives in assets/prv-shared.css.liquid so it's defined once, globally. Respects
   prefers-reduced-motion by doing nothing (the CSS also has a reduced-motion fallback).

   Bundle & Save sticky-sidebar fix (Jen's call, Sep 2026): .prv-bundle-split-grid (the two-column
   "split" bundle-builder layout on the dedicated Bundle & Save page) is excluded from this
   treatment. .prv-reveal sets `will-change: opacity, transform`, and per spec that alone makes
   the browser treat the element as if it had a real transform for the purposes of establishing a
   containing block for descendants — even once the reveal animation finishes and the class is
   never removed. That silently broke `position: sticky` on the nested "Your Bundle" summary
   panel: instead of sticking to the viewport as you scroll, it rendered permanently pushed down
   by its own `top` offset (a fixed +112px), which is exactly the "sidebar starts lower than the
   product grid and doesn't stay in view while scrolling" bug Jen flagged. No other section on the
   site nests a sticky element inside a .prv-reveal target, so this is a narrow, one-element
   exclusion — every other section keeps the fade-in exactly as before. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var targets = document.querySelectorAll(
    'section:not(.prv-header):not(.prv-utility-bar) > .prv-wrap > *:not(.prv-bundle-split-grid), ' +
    '.prv-footer > .prv-wrap > *'
  );
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) return;

  targets.forEach(function (el) {
    el.classList.add('prv-reveal');
  });

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('prv-reveal-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  targets.forEach(function (el) {
    io.observe(el);
  });
})();